export default angular.module('syInputDate', [])
    /**
     * @ngdoc directive
     * @name syInputDate.directive:syInputDate
     * @description
     * Creates a controller to track an entire date control made up of
     * up to three elements (day, month and year) to validate them as a whole
     */
    // @ngInject
    .directive('syInputDate', function () {
        return {
            scope: true,
            restrict: 'A',
            require: 'ngModel',
            link: function ($scope, $element, attrs, ngModel) {
                var isDirty = false;
                // Return true if the provided dateString is a valid date and
                // is a valid dateString within the format YYYY-MM-DD - NO OTHER
                // FORMAT is supported.
                // @param dateString {string} A date in the format YYYY-MM-DD
                var isValidDate = function (dateString) {
                    if (!dateString) {
                        return false;
                    }
                    var dateParts = dateString.split('-');
                    // Ensure that each field has been provided
                    if (dateParts.length !== 3 || dateParts.indexOf('') >= 0) {
                        return false;
                    }
                    // Validate the values provided are a true date and exists
                    var year = dateParts[0];
                    var month = dateParts[1] - 1; // - 1 for 0-11 month range
                    var day = dateParts[2];
                    var d = new Date(year, month, day);
                    return (Object.prototype.toString.call(d) === '[object Date]' &&
                            // ensure date value is an actual time
                            !isNaN(d.getTime()) &&
                            // ensure no date overflow has occured e.g. feb 31
                            (d.getMonth() + 1) === parseInt(dateString.split('-').slice(1, 2), 10));
                };
                // To support 2 way binding on the value from multiple fields this
                // will watch and update the ngModel of the hidden input
                $scope.$watch(function () {
                    return attrs.value;
                }, function (newValue) {
                    ngModel.$setViewValue(newValue);
                });
                // Add custom validation for validDate
                ngModel.$parsers.unshift(function (value) {
                    // These parsers do NOT wait for bindings to be completed
                    // so this catches the situation where the binding parse
                    // is not completed and thus will return the Angular
                    // string instead of the correct value.
                    if (value.indexOf('{{') === 0) {
                        return value;
                    }
                    // Handle custom dirty state. This ensures that the date
                    // field will not be set dirty until ALL three inputs have
                    // been set (not just one of them). This stops an error
                    // validation from triggering after a single field is set
                    // and the date is immediately invalid
                    if (!isDirty && value && value.split('-').indexOf('') >= 0) {
                        ngModel.$setPristine();
                    }
                    else {
                        isDirty = true;
                        ngModel.$setDirty();
                    }
                    ngModel.$setValidity('custom', isValidDate(value));
                    return value;
                });
                ngModel.$formatters.unshift(function (value) {
                    ngModel.$setValidity('custom', isValidDate(value));
                    return value;
                });
            }
        };
    });
